import { Button, ButtonProps } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import WoltModal from 'common/components/WoltModal';
import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

type ActionProps = {
  label: string;
} & ButtonProps;

export type ConfirmModalProps = {
  heading?: string;
  description?: string;
  actions: ActionProps[];
  isOpen?: boolean;
  onClose?(): void;
};

const StyledWrapper = styled(WoltModal)`
  background-color: ${cbSemanticCssVars.surfaceMain};
  width: 250px;
  border-radius: 8px;
  padding: 12px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    min-width: auto;
    width: 98vw;
  }
`;

const StyledHeading = styled(Typography.Heading6)`
  margin-block-start: 4px;
  margin-block-end: 8px;
`;

const StyledActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-block-start: 16px;
  gap: 8px;
`;

const ActionsModal = ({ isOpen, onClose, heading, description, actions }: ConfirmModalProps) => {
  return (
    <StyledWrapper isOpen={!!isOpen} onRequestClose={onClose}>
      {heading && (
        <StyledHeading data-test-id="confirmation-modal__heading">
          <FormattedMessage id={heading} />
        </StyledHeading>
      )}

      {description && (
        <Typography.Body3 fontWeight="semiBold" data-test-id="confirmation-modal__description">
          <FormattedMessage id={description} />
        </Typography.Body3>
      )}

      <StyledActionsWrapper>
        {actions.map(({ label, ...props }) => (
          <Button key={label} {...props}>
            <FormattedMessage id={label} />
          </Button>
        ))}
      </StyledActionsWrapper>
    </StyledWrapper>
  );
};

export default ActionsModal;
